<nav class="paginator-wrapper branding-accent-dark-border">
  <a class="page-marker mod-control branding-accent-dark-border branding-accent-dark-foreground"
     [class.branding-accent-dark-background-hover]="canStep(-1)"
     [attr.disabled]="!canStep(-1)"
     (click)="onStepPage(-1)">
    {{'Controls.previous' | translate}}
  </a>

  <a *ngFor="let page of pages"
       class="page-marker branding-accent-dark-border branding-accent-dark-foreground branding-accent-dark-background-hover"
       [class.branding-accent-dark-background]="page === currentPage"
       [class.mod-selected]="page === currentPage"
       (click)="onPageChange(page)">
    {{page + 1}}
  </a>

  <a class="page-marker mod-control branding-accent-dark-border branding-accent-dark-foreground branding-accent-dark-background-hover"
     [class.branding-accent-dark-background-hover]="canStep(1)"
     [attr.disabled]="!canStep(1)"
     (click)="onStepPage(1)">
    {{'Controls.next' | translate}}
  </a>
</nav>